import { bindContractSummary } from './bindData';
import { generateYearArray, getArmenianLocalDate } from '../dates';

export const getContractSummary = (
  totalDiscount, totalPrice, t, isFetchingPrice,
) => bindContractSummary(
  totalDiscount, totalPrice, t, isFetchingPrice,
);

export const getRoadCareTransportReleasedYears = () => generateYearArray(
  new Date(getArmenianLocalDate()).getFullYear(), 19,
);

export const bindRoadCarePlanDefaultCoveragesDescription = (
  defaultCoverages, language,
  // eslint-disable-next-line array-callback-return
) => defaultCoverages.reduce((acc, item) => {
  if (item.isDefault) {
    return [
      ...acc,
      { label: item.name[language] },
    ];
  }
  return [];
}, []);
